// Settings
import settings from 'settings'

// Utils
import { api } from 'app/views/utils/api'


// get plans
const GETTING_PLANS = 'plan/GETTING_PLANS'
const RECEIVED_PLANS = 'plan/RECEIVED_PLANS'

// add plan
const ADDING_PLAN = 'plan/ADDING_PLAN'
const ADDED_PLAN = 'plan/ADDED_PLAN'

// get plan by uuid
const GETTING_PLAN_BY_UUID = 'plan/GETTING_PLAN_BY_UUID'
const RECEIVED_PLAN_BY_UUID = 'plan/RECEIVED_PLAN_BY_UUID'

// update plan by uuid
const UPDATING_PLAN_BY_UUID = 'plan/UPDATING_PLAN_BY_UUID'
const UPDATED_PLAN_BY_UUID = 'plan/UPDATED_PLAN_BY_UUID'

// delete plan by uuid
const DELETING_PLAN_BY_UUID = 'plan/DELETING_PLAN_BY_UUID'
const DELETED_PLAN_BY_UUID = 'plan/DELETED_PLAN_BY_UUID'
const DELETED_PLAN_BY_UUID_ERROR = 'plan/DELETED_PLAN_BY_UUID_ERROR'

// add plan group
const ADDING_PLAN_GROUP = 'plan/ADDING_PLAN_GROUP'
const ADDED_PLAN_GROUP = 'plan/ADDED_PLAN_GROUP'

// get plan group by uuid
const GETTING_PLAN_GROUP_BY_UUID = 'plan/GETTING_PLAN_GROUP_BY_UUID'
const RECEIVED_PLAN_GROUP_BY_UUID = 'plan/RECEIVED_PLAN_GROUP_BY_UUID'

// update plan group
const UPDATING_PLAN_GROUP = 'plan/UPDATING_PLAN_GROUP'
const UPDATED_PLAN_GROUP = 'plan/UPDATED_PLAN_GROUP'

// delete plan group
const DELETING_PLAN_GROUP = 'plan/DELETING_PLAN_GROUP'
const DELETED_PLAN_GROUP = 'plan/DELETED_PLAN_GROUP'
const DELETED_PLAN_GROUP_ERROR = 'plan/DELETED_PLAN_GROUP_ERROR'

// users by plan
const SET_LOADING_USERS_PLAN = 'plan/SET_LOADING_USERS_PLAN'
const GETTING_USERS_PLAN = 'plan/GETTING_USERS_PLAN'

const USER_PLAN_UPDATED = 'plan/USER_PLAN_UPDATED'

const SET_SELECTED_PHASE_DETAIL = 'plan/SET_SELECTED_PHASE_DETAIL'
const CLEAR_SELECTED_PHASE_DETAIL = 'plan/CLEAR_SELECTED_PHASE_DETAIL'

const initialState = {
  selectedPhaseDetail: 'loading',


  // get plans
  loadingPlans: false,
  hasLoadedPlans: false,
  plans: [],

  // add plan
  addingPlan: false,

  // get plan by uuid
  loadingPlanByUUID: false,
  planMap: {},

  // update plan by uuid
  updatingPlanByUUID: false,

  // delete plan by uuid
  deletingPlanById: false,
  deletingPlanByIdError: '',

  // add plan group
  addingPlanGroup: false,
  currentPlanGroup: {
    uuid: null,
    title: null,
    description: null,
    start_date: null,
    end_date: null,
    content: [],
  },

  // get plan group by uuid
  gettingPlanGroupByUUID: false,

  // update plan group
  updatingingPlanGroup: false,

  // delete plan group
  deletingPlanGroup: false,
  deletingPlanGroupError: '',

  listOfPlansAndGroups: {},

  // users by plan
  isLoadingUsersPlan: true,
  usersPlan: [],
  totalHackersOnPlan: 0,
  perPage: 10000,
  offsetHackersOnPlan: 0,
  orderHackersOnPlanBy: 'email',
  filterHackersOnPlan: '',
  orderDirectionHackersOnPlan: 'asc',
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_SELECTED_PHASE_DETAIL:
      return {
        ...state,
        selectedPhaseDetail: action.selectedPhaseDetail,
      }
    case CLEAR_SELECTED_PHASE_DETAIL:
      return {
        ...state,
        selectedPhaseDetail: 'loading',
      }
    // get plans
    case GETTING_PLANS:
      return {
        ...state,
        loadingPlans: true,
      }
    case RECEIVED_PLANS:
      return {
        ...state,
        loadingPlans: false,
        hasLoadedPlans: true,
        plans: action.plans,
      }
    // add plan
    case ADDING_PLAN:
      return {
        ...state,
        addingPlan: true,
      }
    case ADDED_PLAN:
      return {
        ...state,
        addingPlan: false,
        uuid: action.uuid,
        title: action.title,
        description: action.description,
        default_plan: action.default_plan,
        send_reminders: action.send_reminders,
      }

    // get plan by uuid
    case GETTING_PLAN_BY_UUID:
      return {
        ...state,
        loadingPlanByUUID: true,
      }
    case RECEIVED_PLAN_BY_UUID:
      return {
        ...state,
        loadingPlanByUUID: false,
        planMap: {
          ...state.planMap,
          [action.uuid]: {
            uuid: action.uuid,
            organization_uuid: action.organization_uuid,
            title: action.title,
            description: action.description,
            default_plan: action.default_plan,
            send_reminders: action.send_reminders,
            groups: action.groups,
            is_time_based: action.is_time_based,
            team_uuid: action.team_uuid,
            team_name: action.team_name,
          },
        },
      }

    // update plan by uuid
    case UPDATING_PLAN_BY_UUID:
      return {
        ...state,
        updatingPlanByUUID: true,
      }
    case UPDATED_PLAN_BY_UUID:
      return {
        ...state,
        updatingPlanByUUID: false,
        planMap: {
          ...state.planMap,
          [action.uuid]: {
            uuid: action.uuid,
            title: action.title,
            description: action.description,
            default_plan: action.default_plan,
            send_reminders: action.send_reminders,
            groups: action.groups,
          },
        },
      }

    // delete plan by uuid
    case DELETING_PLAN_BY_UUID:
      return {
        ...state,
        deletingPlanById: true,
        deletingPlanByIdError: '',
      }
    case DELETED_PLAN_BY_UUID:
      return {
        ...state,
        deletingPlanById: false,
        planMap: {}, // TODO: only have it delete the current plan from the map
      }
    case DELETED_PLAN_BY_UUID_ERROR:
      return {
        ...state,
        deletingPlanById: false,
        deletingPlanByIdError: action.error,
      }

    // add plan group
    case ADDING_PLAN_GROUP:
      return {
        ...state,
        addingPlanGroup: true,
      }
    case ADDED_PLAN_GROUP:
      return {
        ...state,
        addingPlanGroup: false,
        currentPlanGroup: {
          uuid: action.uuid,
          title: action.title,
          description: action.description,
          start_date: action.start_date,
          end_date: action.end_date,
          content: action.content,
        },
      }

    // get plan group by uuid
    case GETTING_PLAN_GROUP_BY_UUID:
      return {
        ...state,
        gettingPlanGroupByUUID: true,
      }
    case RECEIVED_PLAN_GROUP_BY_UUID:
      return {
        ...state,
        gettingPlanGroupByUUID: false,
        currentPlanGroup: {
          uuid: action.uuid,
          title: action.title,
          description: action.description,
          start_date: action.start_date,
          end_date: action.end_date,
          content: action.content,
          duration: action.duration
        },
      }

    // update plan group
    case UPDATING_PLAN_GROUP:
      return {
        ...state,
        addingPlanGroup: true,
      }
    case UPDATED_PLAN_GROUP:
      return {
        ...state,
        addingPlanGroup: false,
        currentPlanGroup: {
          uuid: action.uuid,
          title: action.title,
          description: action.description,
          start_date: action.start_date,
          end_date: action.end_date,
          content: action.content,
          duration: action.duration,
        },
      }

    // delete plan group
    case DELETING_PLAN_GROUP:
      return {
        ...state,
        deletingPlanGroup: true,
        deletingPlanGroupError: '',
      }
    case DELETED_PLAN_GROUP:
      return {
        ...state,
        deletingPlanGroup: false,
      }
    case DELETED_PLAN_GROUP_ERROR:
      return {
        ...state,
        deletingPlanGroupError: action.error,
      }
    // plan user list
    case GETTING_USERS_PLAN:
      return {
        ...state,
        usersPlan: action.usersPlan,
        isLoadingUsersPlan: false,
      }
    case USER_PLAN_UPDATED:
      return {
        ...state,
        usersPlan: state.usersPlan.map((user) => {
          if (user.uuid === action.hackerUUID) {
            return {
              ...user,
              plan_title: action.newPlanTitle,
              plan_uuid: action.newPlanUUID,
              deletedFromPlan: action.deletedFromPlan,
            }
          }
          return user
        }),
      }
    default:
      return state
  }
}

export const clearPhaseDetailModal = () => ({
  type: CLEAR_SELECTED_PHASE_DETAIL,
})

export function fetchPhaseDetailModalData(organizationId, teamId, planId, phaseId) {
  return (dispatch, getState) => {

    const state = getState()
    return api({
      method: 'get',
      url: `${settings.urls.hacker}/organizations/${organizationId}/teams/${teamId}/plan/${planId}/phase/${phaseId}`,
      idToken: state.auth.user.idToken,
    })
      .then(({ data }) => {
        dispatch({
          type: SET_SELECTED_PHASE_DETAIL,
          selectedPhaseDetail: data,
        })
      })
      .catch((error) => {
        console.error(error)
      })
  }
}

export function getPlans(organizationId) {
  return (dispatch, getState) => {
    dispatch({
      type: GETTING_PLANS,
    })
    const state = getState()

    return api({
      method: 'get',
      url: `${settings.urls.hacker}/organizations/${organizationId}/plan`,
      idToken: state.auth.user.idToken,
    })
      .then((response) => {
        dispatch({
          type: RECEIVED_PLANS,
          plans: response.data,
        })
      })
      .catch((error) => {
        console.error(error)
      })
  }
}

export function addPlan(organizationId, title, description, defaultPlan, sendReminders, planType, teamUUID, planUUID, teamName = null, overrideMustPassCode = false, teamMustPassCode = false) {
  return (dispatch, getState) => {
    dispatch({
      type: ADDING_PLAN,
    })
    const state = getState()

    return api({
      method: 'post',
      url: `${settings.urls.hacker}/organizations/${organizationId}/plan`,
      idToken: state.auth.user.idToken,
      data: {
        title,
        description,
        default_plan: defaultPlan,
        send_reminders: sendReminders,
        plan_type: planType || 'date',
        team_uuid: teamUUID,
        plan_uuid: planUUID,
        team_name: teamName,
        override_must_pass_code: overrideMustPassCode,
        team_must_pass_code: teamMustPassCode,
      },
    })
      .then((response) => {
        dispatch({
          type: ADDED_PLAN,
          uuid: response.data.uuid,
          title: response.data.title,
          description: response.data.description,
          default_plan: response.data.default_plan,
          send_reminders: response.data.send_reminders,
        })
        return response.data.uuid
      })
      .catch((error) => {
        console.error({ error })
      })
  }
}

export function getPlanById(organizationId, planId) {
  return (dispatch, getState) => {
    dispatch({
      type: GETTING_PLAN_BY_UUID,
    })
    const state = getState()

    return api({
      method: 'get',
      url: `${settings.urls.hacker}/organizations/${organizationId}/plan/${planId}`,
      idToken: state.auth.user.idToken,
    })
      .then((response) => {
        dispatch({
          type: RECEIVED_PLAN_BY_UUID,
          uuid: response.data.uuid,
          organization_uuid: response.data.organization_uuid,
          title: response.data.title,
          description: response.data.description,
          default_plan: response.data.default_plan,
          send_reminders: response.data.send_reminders,
          groups: response.data.groups,
          is_time_based: response.data.is_time_based,
          team_uuid: response.data.team_uuid,
          team_name: response.data.team_name,
        })
      })
      .catch((error) => {
        console.error(error)
      })
  }
}

export function getUsersByPlanId(organizationId, planId) {
  return (dispatch, getState) => {
    dispatch({
      type: SET_LOADING_USERS_PLAN,
      isLoadingUsersPlan: true,
    })
    const state = getState()
    return api({
      method: 'get',
      url: `${settings.urls.hacker}/organizations/${organizationId}/plan/${planId}/users`,
      idToken: state.auth.user.idToken,
      params: {
        filter: state.plan.filterHackersOnPlan,
        order: state.plan.orderHackersOnPlanBy,
        offset: state.plan.offsetHackersOnPlan,
        limit: state.plan.perPage,
        orderDirection: state.plan.orderDirectionHackersOnPlan,
      },
    })
      .then(({ data }) => {
        dispatch({
          type: GETTING_USERS_PLAN,
          usersPlan: data.users,
        })
      })
      .catch((error) => {
        console.error(error)
      })
  }
}

export function addUserToPlan(organizationId, hackerId, planId) {
  return (dispatch, getState) => {
    const state = getState()
    return api({
      method: 'put',
      // /organizations/<organization_uuid>/hackers/<hacker_uuid>/plan
      url: `${settings.urls.hacker}/organizations/${organizationId}/hackers/${hackerId}/plan`,
      idToken: state.auth.user.idToken,
      data: {
        plan_uuid: planId,
      },
    })
      .then(({ data }) => {
        if (data.success === true) {
          dispatch(getUsersByPlanId(organizationId, planId))
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }
}

export function changeUserPhase(organizationId, hackerId, planId, planGroupId, teamId = null, callback = null) {
  return (dispatch, getState) => {
    const state = getState()
    return api({
      method: 'patch',
      // /organizations/<organization_uuid>/hackers/<hacker_uuid>/plan
      url: `${settings.urls.hacker}/organizations/${organizationId}/hackers/${hackerId}/plan`,
      idToken: state.auth.user.idToken,
      data: {
        plan_uuid: planId,
        plan_group_uuid: planGroupId,
        team_uuid: teamId,
      },
    })
      .then(({ data }) => {
        if (data.success === true) {
          if (callback && typeof callback === 'function') {
            callback()
          } else {
            dispatch(getUsersByPlanId(organizationId, planId))
          }
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }
}

export function updatePlanById(organizationId, planId, title, description, defaultPlan, sendReminders, teamUUID) {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATING_PLAN_BY_UUID,
    })
    const state = getState()

    return api({
      method: 'put',
      url: `${settings.urls.hacker}/organizations/${organizationId}/plan/${planId}`,
      idToken: state.auth.user.idToken,
      data: {
        title,
        description,
        default_plan: defaultPlan,
        send_reminders: sendReminders,
        team_uuid: teamUUID,
      },
    })
      .then((response) => {
        dispatch({
          type: UPDATED_PLAN_BY_UUID,
          uuid: response.data.uuid,
          title: response.data.title,
          description: response.data.description,
          send_reminders: response.data.send_reminders,
          groups: response.data.groups,
          team_uuid: teamUUID,
        })
      })
      .catch((error) => {
        console.error(error)
      })
  }
}

export function deletePlanById(organizationId, planId) {
  return (dispatch, getState) => {
    dispatch({
      type: DELETING_PLAN_BY_UUID,
    })
    const state = getState()

    return api({
      method: 'delete',
      url: `${settings.urls.hacker}/organizations/${organizationId}/plan/${planId}`,
      idToken: state.auth.user.idToken,
    })
      .then((response) => {
        if (response.data.error) {
          dispatch({
            type: DELETED_PLAN_BY_UUID_ERROR,
            error: response.data.error,
          })
          return false
        }
        dispatch({
          type: DELETED_PLAN_BY_UUID,
          uuid: planId,
        })
        return true
      })
      .catch((error) => {
        console.error(error)
        dispatch({
          type: DELETED_PLAN_BY_UUID_ERROR,
          error: 'There was an error deleting this plan.',
        })
      })
  }
}

export function addPlanGroup(organizationId, planId, title, description, startDate, endDate, contentIds, duration) {
  return (dispatch, getState) => {
    dispatch({
      type: ADDING_PLAN_GROUP,
    })
    const state = getState()

    return api({
      method: 'post',
      url: `${settings.urls.hacker}/organizations/${organizationId}/plan/${planId}/group`,
      idToken: state.auth.user.idToken,
      data: {
        title,
        description,
        start_date: startDate,
        end_date: endDate,
        content_uuids: contentIds,
        duration: duration || null,
      },
    })
      .then((response) => {
        dispatch({
          type: ADDED_PLAN_GROUP,
          uuid: response.data.uuid,
          title: response.data.title,
          description: response.data.description,
          start_date: response.data.start_date,
          end_date: response.data.end_date,
          content: response.data.content,
          duration: response.data.duration,
        })
        return response.data.uuid
      })
      .catch((error) => {
        console.error(error)
      })
  }
}

export function getPlanGroupById(organizationId, planId, phaseId) {
  return (dispatch, getState) => {
    dispatch({
      type: GETTING_PLAN_GROUP_BY_UUID,
    })
    const state = getState()

    return api({
      method: 'get',
      url: `${settings.urls.hacker}/organizations/${organizationId}/plan/${planId}/group/${phaseId}`,
      idToken: state.auth.user.idToken,
    })
      .then((response) => {
        dispatch({
          type: RECEIVED_PLAN_GROUP_BY_UUID,
          uuid: response.data.uuid,
          title: response.data.title,
          description: response.data.description,
          start_date: response.data.start_date,
          end_date: response.data.end_date,
          content: response.data.content,
          duration: response.data.duration,
        })
        return response.data.uuid
      })
      .catch((error) => {
        console.error(error)
      })
  }
}

export function updatePlanGroup(organizationId, planId, groupId, title, description, startDate, endDate, contentIds, duration) {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATING_PLAN_GROUP,
    })
    const state = getState()

    return api({
      method: 'put',
      url: `${settings.urls.hacker}/organizations/${organizationId}/plan/${planId}/group/${groupId}`,
      idToken: state.auth.user.idToken,
      data: {
        title,
        description,
        start_date: startDate,
        end_date: endDate,
        content_uuids: contentIds,
        duration,
      },
    })
      .then((response) => {
        dispatch({
          type: UPDATED_PLAN_GROUP,
          uuid: response.data.uuid,
          title: response.data.title,
          description: response.data.description,
          start_date: response.data.start_date,
          end_date: response.data.end_date,
          content: response.data.content,
          duration: response.data.duration,
        })
      })
      .catch((error) => {
        console.error(error)
      })
  }
}

export function setCustomPlansNotDefault(organizationId) {
  return (dispatch, getState) => {
    const state = getState()
    return api({
      method: 'patch',
      url: `${settings.urls.hacker}/organizations/${organizationId}/plan`,
      idToken: state.auth.user.idToken,
    })
      .then(({ data }) => {
        if (data.success) {
          window.location.reload()
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }
}

export function deletePlanGroup(organizationId, planId, groupId) {
  return (dispatch, getState) => {
    dispatch({
      type: DELETING_PLAN_GROUP,
    })
    const state = getState()

    return api({
      method: 'delete',
      url: `${settings.urls.hacker}/organizations/${organizationId}/plan/${planId}/group/${groupId}`,
      idToken: state.auth.user.idToken,
    })
      .then(() => {
        dispatch({
          type: DELETED_PLAN_GROUP,
        })
      })
      .catch((error) => {
        console.error(error)
        dispatch({
          type: DELETED_PLAN_GROUP_ERROR,
          error: error.data.error,
        })
      })
  }
}
